export function truncateWord(word: string, prefixLength: number, suffixLength: number) {
  if (!word) {
    return ''
  }
  if (word.length <= prefixLength + suffixLength + 2) {
    return word
  }

  const prefix = word.slice(0, prefixLength)
  const suffix = word.slice(-suffixLength)

  return `${prefix}...${suffix}`
}
